module.exports = __webpack_public_path__ + "img/img-related05.b0feeb08.jpg";